import { render, staticRenderFns } from "./create_api.vue?vue&type=template&id=5e184fb8&scoped=true&"
import script from "./create_api.vue?vue&type=script&lang=js&"
export * from "./create_api.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e184fb8",
  null
  
)

export default component.exports